export default "__VITE_ASSET__DLczaaZ3__";